import React from 'react';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './DistrictsPanel.css';

import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../utils/utils';
import { replaceMultipleSpaces } from '../../lib/utils';


class DistrictsPanel extends React.Component {

  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},

    filter_text: '',
  };

  componentDidMount() {
    const colors = getThemeFromLocalStorage();

    let sourceStyle = layoutColorStyle;

    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };

    if (colors !== 'normal') {

      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };

    }

    this.setState({ colors, sourceStyle, style });

  }

  districtFilterChange = (e) => {
    //zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  render() {

    const { districts, onClick, disabledCondition } = this.props;

    return (
      <div className='well well-sm' style={{ background: this.state.style.backgroundColor }}>
        <h4 style={{ textAlign: 'center' }}>
          <b>Gminy:</b>
        </h4>
        <input type="text"
          className="form-control"
          style={{ width: '100%', position: 'relative', margin: '25px 0px 15px 0px' }}
          value={this.state.filter_text}
          placeholder="Wyszukaj urząd..."
          onChange={(e) => this.districtFilterChange(e)}
        />
        <ul className='nav flex-column' style={{ height: '600px', overflowY: 'scroll' }}>
          {districts && Object.keys(districts).sort()
            .filter(item => districts[item].name.toLowerCase().includes(this.state.filter_text.toLowerCase()))
            .map(item => (

              <li className='nav-item' key={item}>
                <button
                  type="button"
                  className='btn btn-primary'
                  style={{ width: '100%' }}
                  onClick={() => onClick(districts[item].prefix)}
                  disabled={disabledCondition}
                >
                  {districts[item].name}
                </button>
              </li>
            ))
            }
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(DistrictsPanel);



// WEBPACK FOOTER //
// src/components/DistrictsPanel/DistrictsPanel.js